export default {
  width: 22,
  height: 22,
  svg: '<path d="M6.91 6.58266L10 0L13.09 6.58266L20 7.6384L15 12.7636L16.1799 20L10 16.5846L3.82006 20L5.00001 12.7636L0 7.6384L6.91 6.58266Z"/>'
}
